import styled, { keyframes } from 'styled-components';

import { ReactComponent as CloseIconComponent } from '../../../images/close.svg';

export const ModalBackDrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 100;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 786px) {
    align-items: flex-end;
  }
`;

const slideInTopKf = keyframes`
  from {
    transform: translateY(-10px);
  }
  to {
    transform: translateY(0px);
  }
`;

const slideInBottomKf = keyframes`
  from {
    transform: translateY(10px);
  }
  to {
    transform: translateY(0px);
  }
`;

export const Modal = styled.div`
  background-color: #fff;
  z-index: 100;
  box-shadow: 0px 8px 24px -4px rgba(34, 34, 34, 0.08),
    0px 8px 8px 2px rgba(34, 34, 34, 0.08);
  border-radius: 8px;
  max-width: 720px;
  width: 100%;
  max-height: calc(90vh - 90px);
  overflow-y: auto;
  animation: ${slideInTopKf} 200ms ease-in-out;

  @media screen and (max-width: 786px) {
    animation: ${slideInBottomKf} 200ms ease-in-out;
    max-width: unset;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 12px 16px;

  @media screen and (max-width: 786px) {
    padding: 20px 20px 12px 20px;
  }
`;

export const ModalHeaderTitle = styled.h1`
  font-size: 1.7rem;
  font-weight: 600;
  color: #010606;
  margin: 0;

  @media screen and (max-width: 480px) {
    font-size: 1.4rem;
  }
`;

export const ModalHeaderSubTitle = styled.h2`
  font-size: 1.2rem;
  font-weight: 400;
  color: #010606;
  margin: 0;

  @media screen and (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const ModalHeaderCloseIcon = styled(CloseIconComponent)`
  cursor: pointer;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  color: #010606;
  margin-left: 16px;
`;

export const ModalBody = styled.div`
  padding: 24px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.2);

  @media screen and (max-width: 786px) {
    padding: 16px 20px;
  }
`;

export const Tags = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin: 12px 0;
`;

export const Tag = styled.h2`
  font-size: 0.8rem;
  color: #010606;
  white-space: nowrap;
  background: transparent;
  border: 1px solid #010606;
  border-radius: 999px;
  padding: 4px 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;

export const DescriptionHeading = styled.h2`
  font-size: 1.4rem;
  font-weight: 600;
  color: #010606;
  margin: 24px 0 0;

  @media screen and (max-width: 480px) {
    font-size: 1.3em;
  }
`;

export const DescriptionText = styled.div`
  font-size: 1.2rem;
  font-weight: 400;
  color: #010606;
  margin: 0;

  > ul {
    margin-left: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const ProjectImg = styled.img`
  display: block;
  border-radius: 10px;
  max-width: 390px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

  & + & {
    margin-top: 12px;
  }
`;
